import { visit } from 'unist-util-visit';

export const remarkDoubleBold = () => (tree: any) => {
  visit(tree, 'text', (node) => {
    if (node.type === 'text') {
      // eslint-disable-next-line no-param-reassign
      node.value = node.value.replace('****', '');
    }
  });
};
